import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';



const Footernya = ()=>{
    return(
        <div className="foot ">
                <div className="footerini">
                    <nav className="navbar navbar-expand-lg navbar-dark bg-dark text-white " style={{ backgroundImage: 'linear-gradient(to left,#0E0C58, #0C3458, #07A8CB,#07A8CB)' }}>
                        <div className="container-fluid">
                            <h3 className="footer text-light me-auto ms-auto">
                            &copy; 2022 Rama Dhea Yudhistira

                            </h3>

                        </div>
                    </nav>

                </div>

        </div>
    )
}

export default Footernya